import type { Complaint } from '../types/notice';

export const complaintTypes = ['ভুয়া SMS', 'জাল নোটিশ', 'সন্দেহজনক পেমেন্ট লিংক', 'নোটিশের তথ্য অমিল', 'অন্যান্য'];

export const monitoringOfficers = [
  'ইন্সপেক্টর মোঃ মাসুদ রানা',
  'এসআই তাহমিনা সুলতানা',
  'এসআই মোঃ আল আমিন',
  'সাইবার ক্রাইম ইউনিট, ডিএমপি'
];

export const initialComplaints: Complaint[] = [
  {
    id: 'DMP-FR-2026-000144',
    type: 'সন্দেহজনক পেমেন্ট লিংক',
    caseNo: 'DMP/AI/2025/0614/0748',
    vehicle: 'ঢাকা মেট্রো-গ-২৩-৭১০৭',
    name: 'মোঃ মিলন মিয়া',
    mobile: '০১৮৩০০৯০৮১৯',
    date: '১২/১০/২০২৬',
    status: 'নতুন',
    description: 'আমার মোবাইলে একটি SMS এসেছে যেখানে ২৪ ঘণ্টার মধ্যে ৫,০০০ টাকা জরিমানা একটি লিংকে পরিশোধ করতে বলা হয়েছে। লিংকটি ডিএমপির নয় বলে সন্দেহ হচ্ছে।',
    assignedTo: '',
    smsSender: '+8801912XXXXXX',
    smsText: 'DMP TRAFFIC: আপনার গাড়ি ঢাকা মেট্রো-গ-২৩-৭১০৭ এর বিরুদ্ধে মামলা হয়েছে। ২৪ ঘণ্টার মধ্যে ৫০০০ টাকা পরিশোধ করুন: http://dmp-fine-pay.xyz/pay',
    hasNoticeImage: false,
    remarks: []
  },
  {
    id: 'DMP-FR-2026-000143',
    type: 'জাল নোটিশ',
    caseNo: 'DMP/AI/2025/0610/0533',
    vehicle: 'ঢাকা মেট্রো-খ-১৭-২২১০',
    name: 'সুমাইয়া রহমান',
    mobile: '০১৭১৮৪৪২২১০',
    date: '১১/১০/২০২৬',
    status: 'পর্যালোচনাধীন',
    description: 'ডাকযোগে প্রাপ্ত নোটিশে QR কোড স্ক্যান করলে কোনো তথ্য পাওয়া যায়নি। নোটিশের সিল ও স্বাক্ষর অস্পষ্ট।',
    assignedTo: 'এসআই তাহমিনা সুলতানা',
    smsSender: '',
    smsText: '',
    hasNoticeImage: true,
    remarks: [{ by: 'এসআই তাহমিনা সুলতানা', at: '১১/১০/২০২৬, ১৫:২০', text: 'QR টোকেন সিস্টেমে নিবন্ধিত নয়। মূল নথি সংগ্রহের প্রক্রিয়া চলছে।' }]
  },
  {
    id: 'DMP-FR-2026-000142',
    type: 'ভুয়া SMS',
    caseNo: '',
    vehicle: 'ঢাকা মেট্রো-গ-৪১-৩৩০৯',
    name: 'আরিফ চৌধুরী',
    mobile: '০১৬৭৩৩০৯৪৪১',
    date: '১০/১০/২০২৬',
    status: 'ব্যবস্থা গ্রহণ',
    description: 'অজানা নম্বর থেকে মামলার SMS এসেছে কিন্তু মামলা নম্বর দিয়ে যাচাই করে কোনো রেকর্ড পাইনি।',
    assignedTo: 'সাইবার ক্রাইম ইউনিট, ডিএমপি',
    smsSender: '+8801755XXXXXX',
    smsText: 'ট্রাফিক মামলা নং TR-88231। জরিমানা বিকাশে পরিশোধ করুন ০১৭৫৫XXXXXX নম্বরে, অন্যথায় লাইসেন্স বাতিল হবে।',
    hasNoticeImage: false,
    remarks: [{ by: 'ইন্সপেক্টর মোঃ মাসুদ রানা', at: '১০/১০/২০২৬, ১২:০৫', text: 'প্রেরক নম্বর সাইবার ক্রাইম ইউনিটে হস্তান্তর করা হয়েছে।' }]
  },
  {
    id: 'DMP-FR-2026-000141',
    type: 'নোটিশের তথ্য অমিল',
    caseNo: 'DMP/AI/2025/0613/0702',
    vehicle: 'ঢাকা মেট্রো-ঘ-১২-৩৩৪৫',
    name: 'সাইফুল ইসলাম',
    mobile: '০১৮১৯২২৩৩৪৪',
    date: '০৯/১০/২০২৬',
    status: 'নিষ্পত্তিকৃত',
    description: 'নোটিশে মালিকের নামের বানান ভুল ছিল।',
    assignedTo: 'এসআই মোঃ আল আমিন',
    smsSender: '',
    smsText: '',
    hasNoticeImage: true,
    remarks: [{ by: 'এসআই মোঃ আল আমিন', at: '০৯/১০/২০২৬, ১৬:৪০', text: 'নতুন সংস্করণ ইস্যু করা হয়েছে; পূর্বের নোটিশ প্রতিস্থাপিত হিসেবে চিহ্নিত।' }]
  },
  {
    id: 'DMP-FR-2026-000140',
    type: 'ভুয়া SMS',
    caseNo: '',
    vehicle: 'ঢাকা মেট্রো-চ-১১-০৯৮৭',
    name: 'নুসরাত জাহান',
    mobile: '০১৯১৪০৯৮৭২২',
    date: '০৮/১০/২০২৬',
    status: 'পর্যালোচনাধীন',
    description: 'SMS এ একটি সংক্ষিপ্ত লিংক দেওয়া হয়েছে এবং ব্যক্তিগত তথ্য চাওয়া হয়েছে।',
    assignedTo: 'এসআই তাহমিনা সুলতানা',
    smsSender: 'DMP-INFO',
    smsText: 'আপনার গাড়ির বিরুদ্ধে ট্রাফিক মামলা। বিস্তারিত দেখুন: bit.ly/dmp-case-check',
    hasNoticeImage: false,
    remarks: []
  },
  {
    id: 'DMP-FR-2026-000139',
    type: 'অন্যান্য',
    caseNo: 'DMP/AI/2025/0611/0617',
    vehicle: 'ঢাকা মেট্রো-ন-২৬-৩০৪১',
    name: 'কামাল হোসেন',
    mobile: '০১৬১২৩০৪১৫৫',
    date: '০৭/১০/২০২৬',
    status: 'নিষ্পত্তিকৃত',
    description: 'নোটিশ ডাকযোগে দেরিতে পৌঁছেছে।',
    assignedTo: 'ইন্সপেক্টর মোঃ মাসুদ রানা',
    smsSender: '',
    smsText: '',
    hasNoticeImage: false,
    remarks: [{ by: 'ইন্সপেক্টর মোঃ মাসুদ রানা', at: '০৭/১০/২০২৬, ১১:১০', text: 'ডাক রেফারেন্স যাচাই করে নাগরিককে অবহিত করা হয়েছে।' }]
  }
];
